var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonScatterHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#FDBB2D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(209 500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -65.7L65.7 0L0 65.7L-65.7 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L15 0L0 15L-15 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349 68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -33L33 0L0 33L-33 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(743 496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -48L48 0L0 48L-48 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544 312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -36L36 0L0 36L-36 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185 251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -47L47 0L0 47L-47 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(726 323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -37L37 0L0 37L-37 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(850 207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -14L14 0L0 14L-14 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864 584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12L12 0L0 12L-12 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -39L39 0L0 39L-39 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(586 509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -51L51 0L0 51L-51 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -41L41 0L0 41L-41 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -51L51 0L0 51L-51 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(570 67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -41L41 0L0 41L-41 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404 467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -53L53 0L0 53L-53 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -62L62 0L0 62L-62 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(724 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -50L50 0L0 50L-50 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(856 350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -28L28 0L0 28L-28 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -10L10 0L0 10L-10 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505 183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -19L19 0L0 19L-19 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(859 28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -29L29 0L0 29L-29 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319 589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L15 0L0 15L-15 0Z",
    fill: "#C62828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(239 372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -23L23 0L0 23L-23 0Z",
    fill: "#C62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScatterHaikei);
export default __webpack_public_path__ + "static/media/polygon-scatter-haikei.a530e361d52072fe9cdea8c326f01cde.svg";
export { ForwardRef as ReactComponent };